<div
    class="row mx-auto px-3"
    *ngIf="!localData || !localData.length"
>
    <div class="col-lg-12">{{ i18n._852_NO_DATA | translate }}.</div>
</div>
<div class="row mx-auto px-3">
    <div class="col-lg-12 pb-2">
        <table class="tab-performance-table">
            <thead>
                <tr class="tab-performance-table-date">
                    <th></th>
                    <th
                        *ngFor="let p of periodsData"
                        [colSpan]="colSpan"
                    >
                        {{ getPeriodText(p) }}
                    </th>
                </tr>
                <tr
                    class="tab-performance-table-metric-header"
                    *ngIf="colSpan > 1"
                >
                    <th></th>
                    <th *ngFor="let m of metricNames">{{ m }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="perf-row-title">
                        {{ i18n._725_ACTUAL | translate }}
                    </td>
                    <td *ngFor="let d of localData">
                        <span [style.color]="d.arrowColour">{{
                            d.actual != null
                                ? (d.actual | number: '1.0-1')
                                : '-'
                        }}</span>
                        <cmps-icon
                            [style.fill]="d.arrowColour"
                            [svgIcon]="d.arrow"
                            *ngIf="d.trend"
                        ></cmps-icon>
                    </td>
                </tr>
                <tr>
                    <td class="perf-row-title">
                        {{ i18n._726_TARGET | translate }}
                    </td>
                    <td *ngFor="let d of localData">
                        {{
                            d.target != null
                                ? (d.target | number: '1.0-1')
                                : '-'
                        }}
                    </td>
                </tr>
                <tr>
                    <td class="perf-row-title">
                        {{ i18n._768___TO_TARGET | translate }}
                    </td>
                    <td
                        *ngFor="let d of localData"
                        [style.color]="d.targetThresholdColour"
                    >
                        {{
                            d.targetPercent != null
                                ? d.targetPercent >= 999
                                    ? '999+'
                                    : (d.targetPercent | number: '1.0-1')
                                : '-'
                        }}
                    </td>
                </tr>
                <tr>
                    <td class="perf-row-title">
                        {{ i18n._721_GOAL | translate }}
                    </td>
                    <td *ngFor="let d of localData">
                        {{ d.goal != null ? (d.goal | number: '1.0-1') : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="perf-row-title">
                        {{ i18n._7367___TO_GOAL | translate }}
                    </td>
                    <td
                        *ngFor="let d of localData"
                        [style.color]="d.goalThresholdColour"
                    >
                        {{ (d.goalPercent | number: '1.0-1') || '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="perf-row-title">
                        {{ i18n._7368_OPPORTUNITY_THRESHOLD | translate }} (%)
                    </td>
                    <td *ngFor="let d of localData">
                        {{
                            d.opportunityThreshold
                                ? (d.opportunityThreshold | number: '1.0-1')
                                : '-'
                        }}
                    </td>
                </tr>
                <tr>
                    <td class="perf-row-title">
                        {{ i18n._7369_GAP_TO_OPPORTUNITY_LINE | translate }}
                    </td>
                    <td *ngFor="let d of localData">
                        {{ d.gap ? (d.gap | number: '1.0-1') : '-' }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
